import React from 'react';
import { Grid } from '@mui/material';

const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const CalendarWeekHeader: React.FC = () => (
  <Grid
    container
    sx={{
      display: 'grid',
      gridTemplateColumns: 'repeat(7, 1fr)',
    }}
  >
    {weekDays.map((day) => (
      <Grid
        key={day}
        sx={{
          px: 1,
          py: '6px',
          textAlign: 'start',
          color: '#7B8BAD',
          fontFamily: 'Poppins',
          fontSize: '11px',
          fontWeight: 600,
        }}
      >
        {day}
      </Grid>
    ))}
  </Grid>
);

export default CalendarWeekHeader;
